// extracted by mini-css-extract-plugin
module.exports = {"homepageCenter":"index_homepageCenter__Cqlqc","contentColumn":"index_contentColumn__YcsIw"};